"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PERMISSIONS = exports.PERMISSIONS = void 0;
exports.canEditPermissions = canEditPermissions;
exports.canGrantPermission = canGrantPermission;
exports.togglePermissions = togglePermissions;
const model_1 = require("./model");
exports.PERMISSIONS = {
    key: "",
    title: "Permissions",
    children: [
        {
            key: "manage.roster",
            feature: model_1.Feature.Roster,
            requiresRole: model_1.Role.Manager,
            title: "Dienstplan",
            description: "Der Mitarbeiter kann für bestimmte Abteilungen Dienstpläne schreiben und veröffentlichen.",
            grid: true,
            icon: "table",
            children: [
                {
                    title: "Einsehen & Bearbeiten",
                    key: "manage.roster",
                    icon: "pencil",
                    readonly: true,
                    requires: [`manage.roster`],
                },
                {
                    title: "Veröffentlichen",
                    key: "manage.roster.publish",
                    requires: ["manage.roster"],
                    icon: "paper-plane",
                },
                {
                    title: "Kosten Einsehen",
                    key: "manage.roster.costs",
                    requires: ["manage.roster"],
                    icon: "euro-sign",
                },
                {
                    title: "Notizen Verwalten",
                    key: "manage.roster.notes",
                    requires: ["manage.roster"],
                    icon: "sticky-note",
                },
            ],
        },
        {
            key: "manage.employees",
            feature: model_1.Feature.Employees,
            requiresRole: model_1.Role.Manager,
            title: "Mitarbeiter",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Mitarbeiter und kann dort Stammdaten, Arbeitsbereiche und Berechtigungen einsehen und bearbeiten.",
            grid: true,
            icon: "people-group",
            children: [
                {
                    key: "manage.employees.time",
                    title: "Arbeitszeiten",
                    icon: "hourglass-clock",
                },
                {
                    key: "manage.employees.absences",
                    title: "Abwesenheiten",
                    icon: "person-to-portal",
                },
                {
                    key: "manage.employees.availabilities",
                    title: "Verfügbarkeiten",
                    icon: "comment-check",
                },
                {
                    key: "manage.employees.documents",
                    title: "Dokumente",
                    icon: "files",
                },
                {
                    key: "manage.employees.payroll",
                    title: "Löhne",
                    icon: "sack-dollar",
                },
                {
                    key: "manage.employees.advances",
                    title: "Vorschüsse",
                    icon: "hand-holding-dollar",
                },
                {
                    key: "manage.employees.ledgers",
                    title: "Konten",
                    icon: "scale-unbalanced",
                },
                {
                    key: "manage.employees.core_data",
                    title: "Stammdaten",
                    icon: "address-card",
                },
                {
                    key: "manage.employees.contract",
                    title: "Verträge",
                    icon: "file-contract",
                },
                {
                    key: "manage.employees.permissions",
                    title: "Zugänge & Rechte",
                    icon: "user-lock",
                },
                {
                    key: "manage.employees.positions",
                    title: "Positionen",
                    icon: "arrows-down-to-people",
                },
                {
                    key: "manage.employees.create",
                    title: "Mitarbeiter Anlegen",
                    icon: "person-circle-plus",
                },
                {
                    key: "manage.employees.delete",
                    title: "Mitarbeiter Löschen",
                    icon: "person-circle-minus",
                },
                {
                    key: "manage.employees.messages",
                    title: "Nachrichten Versenden",
                    icon: "message-lines",
                },
            ],
        },
        {
            key: "manage.settings",
            requiresRole: model_1.Role.Manager,
            title: "Einstellungen",
            description: "Der Mitarbeiter kann Änderungen an den Grundeinstellungen vornehmen.",
            grid: true,
            icon: "cog",
            children: [
                {
                    key: "manage.settings.company",
                    title: "Unternehmen",
                    icon: "building",
                },
                {
                    key: "manage.settings.venues",
                    title: "Arbeitsbereiche",
                    icon: "sitemap",
                },
                {
                    key: "manage.settings.time",
                    title: "Zeiterfassung",
                    icon: "stopwatch",
                },
                {
                    key: "manage.settings.core_data",
                    title: "Stammdaten",
                    icon: "address-card",
                },
                {
                    key: "manage.settings.documents",
                    title: "Dokumente",
                    icon: "files",
                },
                {
                    key: "manage.settings.bonuses",
                    title: "Zuschläge",
                    icon: "badge-percent",
                },
                {
                    key: "manage.settings.benefits",
                    title: "Sonderleistungen",
                    icon: "hand-holding-box",
                },
                {
                    key: "manage.settings.accounting",
                    title: "Buchhaltung",
                    icon: "abacus",
                },
                {
                    key: "manage.settings.billing",
                    title: "Rechnungsstellung",
                    icon: "file-invoice-dollar",
                },
            ],
        },
        {
            key: "manage.time",
            feature: model_1.Feature.Time,
            requiresRole: model_1.Role.Manager,
            title: "Zeiterfassung",
            grid: true,
            icon: "stopwatch",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Zeiterfassung " +
                "und kann dort erfasste Arbeitszeiten einsehen. Desweiteren kann er " +
                "das Zeiterfassungsystem (Pentatime) auf Endgeräten einrichten und verwalten.",
            children: [
                {
                    title: "Einsehen & Bearbeiten",
                    key: "manage.time",
                    readonly: true,
                    requires: ["staff.roster"],
                    icon: "pencil",
                },
                {
                    title: "Protokoll Einsehen",
                    key: "manage.time.events",
                    requires: ["manage.time"],
                    icon: "timeline-arrow",
                },
            ],
        },
        {
            key: "manage.revenues",
            feature: model_1.Feature.Revenues,
            requiresRole: model_1.Role.Manager,
            title: "Umsätze",
            icon: "euro-sign",
            grid: true,
            children: [
                { icon: "chart-line", key: `manage.revenues.all`, title: "Alle Umsätze" },
                { icon: "cash-register", key: `manage.revenues.daily`, title: "Tagesabrechnung" },
                { icon: "book", key: `manage.revenues.cashbook`, title: "Kassenbuch" },
                { icon: "file-invoice-dollar", key: `manage.revenues.debtors`, title: "Debitoren" },
                { icon: "filter-circle-dollar", key: `manage.revenues.groups`, title: "Umsatzgruppen" },
            ],
        },
        {
            key: "manage.planning",
            feature: model_1.Feature.Planning,
            requiresRole: model_1.Role.Manager,
            title: "Planung",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Planung und kann dort " +
                "Planumsätze und Stundenvorgaben definieren.",
            grid: true,
            icon: "calendar",
            children: [
                { key: `manage.planning.revenue`, title: "Umsätze", icon: "euro-sign" },
                { key: `manage.planning.roster`, title: "Stundenvorgaben", icon: "bars-progress" },
            ],
        },
        {
            key: "manage.reports",
            requiresRole: model_1.Role.Manager,
            title: "Berichte",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Berichte und kann dort " +
                "verschiedene Kennzahlen und Analysen einsehen.",
            grid: true,
            icon: "chart-pie",
            children: [
                { key: `manage.reports.savings`, title: "Ersparnis", icon: "piggy-bank" },
                { key: `manage.reports.costs`, title: "Personalkosten", icon: "hand-holding-dollar" },
                { key: `manage.reports.time`, title: "Arbeitszeit", icon: "hourglass-clock" },
                { key: `manage.reports.revenue`, title: "Umsätze", icon: "sack-dollar" },
            ],
        },
        {
            key: "manage.issues",
            requiresRole: model_1.Role.Manager,
            title: "Probleme",
            icon: "exclamation-triangle",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Probleme und kann dort " +
                "Arbeitszeit- und Vertragsbezogene Probleme einsehen, beheben und verwerfen.",
        },
        {
            key: "manage.recruiting",
            requiresRole: model_1.Role.Manager,
            title: "Recruiting",
            icon: "image-polaroid-user",
            description: "Der Mitarbeiter hat Zugriff auf den Bereich Recruiting und kann dort " +
                "Stellenausschreibungen bearbeiten und Bewerbungen einsehen und beantworten.",
        },
        {
            key: "manage.exports",
            requiresRole: model_1.Role.Manager,
            title: "Datenexport",
            description: 'Der Mitarbeiter hat Zugriff auf den Bereich "Datenexport" und kann dort ' +
                "verschiedene Bewegungs- und Stammdaten exportieren.",
            grid: true,
            icon: "download",
            children: [
                {
                    key: "manage.exports.payroll",
                    title: "Lohnbuchhaltung",
                    icon: "hand-holding-dollar",
                },
                {
                    key: "manage.exports.time",
                    title: "Arbeitszeiten",
                    icon: "list-timeline",
                },
                {
                    key: "manage.exports.roster",
                    title: "Dienstplan",
                    icon: "table",
                },
                {
                    key: "manage.exports.employee_data",
                    title: "Stammdaten",
                    icon: "address-card",
                },
                {
                    key: "manage.exports.cashbook",
                    title: "Kassenbuch",
                    icon: "book",
                },
                {
                    key: "manage.exports.ledgers",
                    title: "Konten",
                    icon: "scale-unbalanced",
                },
            ],
        },
        {
            key: "staff.roster",
            title: "Dienstplan",
            description: "Der Mitarbeiter kann seinen persönlichen Dienstplan einsehen",
            grid: true,
            icon: "table",
            children: [
                {
                    title: "Einsehen",
                    key: "staff.roster",
                    readonly: true,
                    requires: ["staff.roster"],
                    icon: "eye",
                },
                {
                    title: "Schichten Übernehmen",
                    key: "staff.roster.take",
                    requires: ["staff.roster"],
                    icon: "hand-back-fist",
                },
                {
                    title: "Zum Tausch Freigeben",
                    key: "staff.roster.offer",
                    requires: ["staff.roster"],
                    icon: "hand-holding-magic",
                },
            ],
        },
        {
            key: "staff.absences",
            title: "Abwesenheiten",
            description: "Der Mitarbeiter kann seine eigenen Abwesenheitszeiträume einsehen, Urlaubsanträge stellen und Krankmeldungen einreichen.",
            grid: true,
            icon: "person-to-portal",
            children: [
                {
                    title: "Einsehen",
                    key: "staff.absences",
                    readonly: true,
                    requires: ["staff.absences"],
                    icon: "eye",
                },
                {
                    title: "Urlaubsanträge",
                    key: "staff.absences.request_vacation",
                    requires: ["staff.absences"],
                    icon: "comment-question",
                },
                {
                    title: "Krankmeldungen",
                    key: "staff.absences.request_sick",
                    requires: ["staff.absences"],
                    icon: "face-vomit",
                },
            ],
        },
        {
            key: "staff.availabilities",
            title: "Verfügbarkeiten",
            description: "Der Mitarbeiter kann über die Mitarbeiter-App Verfügbarkeiten eintragen.",
            icon: "comment-check",
        },
        {
            key: "staff.time",
            title: "Arbeitszeiten",
            description: "Der Mitarbeiter kann seine eigenen Arbeitszeiten einsehen.",
            icon: "hourglass-clock",
        },
        {
            key: "staff.ledgers",
            title: "Konten",
            description: "Der Mitarbeiter kann seine eigenen Konten einsehen.",
            icon: "scale-unbalanced",
        },
        {
            key: "staff.tracking",
            title: "Stempeluhr",
            description: "Der Mitarbeiter kann über die Mitarbeiter-App Zeiten stempeln.",
            icon: "stopwatch",
        },
        {
            key: "staff.documents",
            title: "Dokumente",
            description: "Der Mitarbeiter kann seine eigenen Dokumente einsehen.",
            icon: "files",
        },
    ],
};
function recursiveGetPermissions(scopeDef) {
    const scopes = scopeDef.key ? [scopeDef.key] : [];
    if (scopeDef.children) {
        for (const scope of scopeDef.children) {
            scopes.push(...recursiveGetPermissions(scope));
        }
    }
    return scopes;
}
exports.ALL_PERMISSIONS = recursiveGetPermissions(exports.PERMISSIONS);
function canEditPermissions(params, profileId) {
    const isOwner = params.role <= model_1.Role.Owner;
    const isSelf = profileId != null && params.id === profileId;
    return !isOwner && !isSelf;
}
function canGrantPermission(permission, grantingProfile, asAdmin = false) {
    if (!grantingProfile || !permission) {
        return false; // No profile to check against
    }
    if (grantingProfile.role <= model_1.Role.Owner || asAdmin) {
        return true; // Owners and Admins can grant all permissions
    }
    return grantingProfile.hasPermission(permission);
}
/**
 * Toggles permissions based on user's granting abilities.
 * When checking a permission, only grants sub-permissions the user can grant.
 * When unchecking, only removes sub-permissions the user can grant.
 */
function togglePermissions({ currentPermissions, checked, grantingProfile, relatedPermissions, asAdmin = false, }) {
    const { sub, requires } = relatedPermissions;
    if (checked) {
        // If we checked a permission, we add all sub permissions that the current user can grant
        const grantableSub = sub.filter((permission) => canGrantPermission(permission, grantingProfile, asAdmin));
        return [...new Set([...currentPermissions, ...grantableSub])];
    }
    else {
        // If we uncheck a permission, we remove only the sub permissions that the current user can grant
        // and all permissions that require this permission
        const removableSub = sub.filter((permission) => canGrantPermission(permission, grantingProfile, asAdmin));
        return currentPermissions.filter((p) => ![...removableSub, ...requires].includes(p));
    }
}
//# sourceMappingURL=permissions.js.map